/* eslint-disable */
import axios from 'axios'

const SERVICERECOMMANDAPI = '/Service/recommand'

// 邀请参赛送积分记录提交
function competitionInvitation(senddata) {
  console.log(senddata, 'senddata');
  const url = `${SERVICERECOMMANDAPI}/competition/invitation`
  const formData = new FormData()
  formData.append('inviteeMobile', senddata.inviteeMobile)
  formData.append('type', senddata.type)
  formData.append('uid', senddata.uid)
  formData.append('code', senddata.code)
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
  return new Promise(function (resolve, reject) {
    axios.post(url, formData, config).then(
      m => {
        resolve(m.data)
      }
    ).catch(function (err) {
      reject(err)
    })
  })
}

export default {
  competitionInvitation
}


// WEBPACK FOOTER //
// ./src/common/ajax/API/RECOMMAND.js